import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { MultiPoint, LineString } from 'ol/geom.js';
import { VectorLayer } from '../layers/RendererLayer.js';
import { Feature } from 'ol';
import { Vector as VectorSource } from 'ol/source.js';
import { Modify } from 'ol/interaction.js';
import { platformModifierKeyOnly, primaryAction } from 'ol/events/condition.js';
import cspline from 'ol-ext/render/Cspline';

export class PlaylineLayer extends VectorLayer {
	map;
	focusedHoleId;
	isActive = false;
	constructor(map) {
		let source = new VectorSource()
		super({
			source: source,
			zIndex: 9999
		});
		let _this = this
		this.map = map;
		this.updateStyle()
		let pixelTolerance = 7
		let modify = new Modify({
			source: source,
			pixelTolerance: pixelTolerance, 
			condition: function (event) {
				let teePoint = _this.teePoint
				let greenPoint = _this.greenPoint
				if(!teePoint || !greenPoint){
					return false
				}
				var p0 = event.pixel;
				var p1 = map.getPixelFromCoordinate(greenPoint.getGeometry().getCoordinates());
				var dx = p0[0] - p1[0];
				var dy = p0[1] - p1[1];
				if (Math.sqrt(dx * dx + dy * dy) <= pixelTolerance) {
					return false;
				}
				var p1 = map.getPixelFromCoordinate(teePoint.getGeometry().getCoordinates());
				var dx = p0[0] - p1[0];
				var dy = p0[1] - p1[1];
				if (Math.sqrt(dx * dx + dy * dy) <= pixelTolerance) {
					return false;
				}
				return primaryAction(event) && !platformModifierKeyOnly(event);
			},
		});
		modify.on('modifyend', function (event) {
			let feature = event.features.getArray()[0]
			let coordinates = [...feature.getGeometry().getCoordinates()]
			coordinates.shift()
			coordinates.pop();
			_this.coordinates = coordinates
			if(_this.onPlaylineChanged) {
				_this.onPlaylineChanged(_this.holeId, {
					coordinates: coordinates,
					greenPoint: _this.greenPoint.get('elementName'),
					teePoint: _this.teePoint.get('elementName')
				})
			} else {
				console.warn("onPlaylineChanged not set")
			}
			
		});
		this.modify = modify;

	}
	updateStyle() {
		let isActive = this.isActive
		let arr = []
		arr.push(new Style({
			geometry: function(feature) {

				return new LineString(cspline(feature.getGeometry().getCoordinates(), { tension: 0.5, pointsPerSeg: 50, normalize: true }))
			},
			stroke: new Stroke({
				color: 'black',
				width: 1,
				lineDash: [5, 5]
			}),
			zIndex: this.isActive ? 9999 : 0
		}))
		if(this.isActive) {
			arr.push(new Style({
				stroke: new Stroke({
					color: this.isActive ? 'blue' : 'blue',
					width: 2,
				}),
				zIndex: this.isActive ? 9999 : 0
			}))
		}
		if(this.isActive) {
			arr.push(new Style({
				geometry: function (feature) {
					let coordinates = [...feature.getGeometry().getCoordinates()]
					coordinates.pop()
					coordinates.shift()
					return new MultiPoint(coordinates);
				},
				image: new CircleStyle({
					radius: 7,
					fill: new Fill({
						color: 'blue',
					})				
				}),
				zIndex: 9999
			}))
		}
		this.setStyle(arr)
	}
	update() {
		let source = this.props.frameSource
		let greenPoint = source.getFeatures().find((f) => f.get('elementName') === this.props.greenPoint)
		let teePoint = source.getFeatures().find((f) => f.get('elementName') === this.props.teePoint)
		if(!greenPoint) {
			console.warn('greenPoint not found')
			if(this.greenPoint) {
				this.greenPoint = null
			}
			this.feature = null
			this.getSource().clear()
			return
		}
		if(!teePoint) {
			console.warn('teePoint not found')
			if(this.teePoint) {
				this.teePoint = null
			}
			this.feature = null
			this.getSource().clear()
			return
		}
		this.greenPoint = greenPoint
		this.teePoint = teePoint
		this.props.assembledCoordinates = [
			teePoint.getGeometry().getCoordinates(),
			...this.props.coordinates,
			greenPoint.getGeometry().getCoordinates()
		]
		const line = new LineString(this.props.assembledCoordinates);
		if(this.feature) {
			this.feature.setGeometry(line)
		} else {
			const feature = new Feature({
				geometry: line
			});
			feature.set('objectType', 'playline');
			this.feature = feature
			this.getSource().addFeature(feature);
		}
	}
	link(props) {
		if(!props) {
			console.warn("no props")
			return
		}
		let f = this.update.bind(this)
		this.unlink()
		this.props = props
		this.holeId = props.holeId
		this.coordinates = props.coordinates
		props.frameSource.on('change', f)
		this.update()
	}
	unlink() {
		this.getSource().clear()
		let f = this.update.bind(this)
		if(this.props) {
			this.props.frameSource.un('change', f)
		}
		this.greenPoint = null
		this.teePoint = null
		this.coordinates = null
		this.holeId = null
		this.feature = null
		this.deactivate()
	}
	activate() {
		if (this.feature) {
			this.setZIndex(9999)
			this.setOpacity(1)
			this.isActive = true
			this.map.addInteraction(this.modify);
		} else {
			this.deactivate()
		}
		this.updateStyle()
	}
	deactivate() {
		this.isActive = false
		this.setOpacity(0.5)
		this.setZIndex(0)
		if(this.modify) {
			this.map.removeInteraction(this.modify);
		}
		this.updateStyle()
	}
}
